import React, { useState } from 'react';
import { useFormik } from 'formik';
import { Col, Row, Container, Form, Alert } from 'react-bootstrap';
import axios from 'axios';
import * as Yup from 'yup';

import './contact-form.styles.scss';

const ContactSchema = Yup.object().shape({
  email: Yup.string()
    .email('Email field must contain a valid email')
    .required('Email field is required'),
  name: Yup.string()
    .typeError('Name field must be valid')
    .min(2)
    .required('Name field is required'),
  phoneNumber: Yup.string().matches(
    /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/,
    'Phone number must be valid'
  ),
  message: Yup.string()
    .typeError('Message field must be valid')
    .required('Message field is required'),
});

const ContactForm = () => {
  const [formSubmitted, setFormSubmitted] = useState<boolean>(false);
  const [formError, setFormError] = useState<string | null>(null);
  const {
    handleChange,
    handleBlur,
    handleSubmit,
    errors,
    touched,
    values,
    resetForm,
  } = useFormik({
    validationSchema: ContactSchema,
    initialValues: { email: '', name: '', phoneNumber: '', message: '' },
    onSubmit: async ({ email, name, phoneNumber, message }) => {
      try {
        setFormError(undefined);

        await axios.post('https://formcarry.com/s/Luhonmi9ld', {
          email,
          name,
          phoneNumber,
          message,
        });
        setFormSubmitted(true);
        resetForm();
      } catch (error) {
        setFormError(error.message);
      }
    },
  });
  return (
    <div className="contact pb-100">
      <Container>
        <div className="section-title">
          <span className="sub-title">Get in Touch</span>
          <h2>Ready to Get Started?</h2>
          <p>
            We take privacy seriously, your email address will not be shared or
            published with anyone but Hop In.
          </p>
        </div>

        <Row>
          <Col lg={6} md={12}>
            <div className="contact-image">
              <img
                src={require('../../../assets/photos/contact.png')}
                alt="contact"
              />
            </div>
          </Col>

          <Col lg={6} md={12}>
            <div className="contact-form">
              {formSubmitted && (
                <Alert variant="success">
                  Hop In has received your email submission. A Hop In
                  representative to contact you shortly.
                </Alert>
              )}
              {formError && <Alert variant="danger">{formError}</Alert>}
              <Form noValidate onSubmit={handleSubmit}>
                <Row>
                  <Form.Group
                    as={Col}
                    lg="12"
                    md="12"
                    controlId="emailValidation"
                  >
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder="Your email address"
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isValid={touched.email && !errors.email}
                      isInvalid={!!errors.email}
                      required
                    />
                    {errors.email && (
                      <Form.Control.Feedback type="invalid">
                        {errors.email}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>
                  <Form.Group as={Col} lg="6" md="6" controlId="nameValidation">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      id="name"
                      name="name"
                      placeholder="Your name"
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isValid={touched.name && !errors.name}
                      isInvalid={!!errors.name}
                      required
                    />
                    {errors.name && (
                      <Form.Control.Feedback type="invalid">
                        {errors.name}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>
                  <Form.Group
                    as={Col}
                    lg="6"
                    md="6"
                    controlId="phoneValidation"
                  >
                    <Form.Label>Phone Number</Form.Label>
                    <Form.Control
                      type="tel"
                      name="phoneNumber"
                      placeholder="Your phone number"
                      value={values.phoneNumber}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isValid={touched.phoneNumber && !errors.phoneNumber}
                      isInvalid={!!errors.phoneNumber}
                      required
                    />
                    {errors.phoneNumber && (
                      <Form.Control.Feedback type="invalid">
                        {errors.phoneNumber}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>

                  <Form.Group
                    as={Col}
                    lg="12"
                    md="12"
                    controlId="messageValidation"
                  >
                    <Form.Label>Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={6}
                      cols={30}
                      name="message"
                      placeholder="Write your message..."
                      value={values.message}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isValid={touched.message && !errors.message}
                      isInvalid={!!errors.message}
                      required
                    />
                    {errors.message && (
                      <Form.Control.Feedback type="invalid">
                        {errors.message}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>

                  <Form.Control hidden name="_gotcha" />

                  <Col lg={12} md={12}>
                    <button type="submit" className="default-btn">
                      <i className="flaticon-tick"></i>
                      Send Message <span></span>
                    </button>
                  </Col>
                </Row>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ContactForm;
